import React from 'react'

export default function Footer() {
  return (
    <>
    <hr/>
    <div id="footer" className='container'>
        <center>Created by <strong>Aman Tiwari</strong> with ❤</center>
        <center><a href="https://www.linkedin.com/in/aman-tiwari001">My LinkedIn</a></center>
        <center><a href="https://www.github.com/aman-tiwari001">My GitHub</a></center>
    </div>
    </>
  )
}
